"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndicatorTypeEnum = void 0;
var IndicatorTypeEnum;
(function (IndicatorTypeEnum) {
    IndicatorTypeEnum["Positive"] = "positive";
    IndicatorTypeEnum["Negative"] = "negative";
})(IndicatorTypeEnum = exports.IndicatorTypeEnum || (exports.IndicatorTypeEnum = {}));
//# sourceMappingURL=indicator-type-enum.js.map